var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiwIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 84,
    viewBox: "0 0 61 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4849 11.5819C47.8462 12.0774 49.1568 12.6513 50.4128 13.2963C39.0831 15.7008 30.0023 21.6823 26.657 30.873C21.4487 45.1848 31.4632 62.4813 49.92 73.7543C41.9174 77.7124 32.3726 78.5196 23.3207 75.225C5.74647 68.8282 -3.31466 49.3954 3.08189 31.8211C9.47856 14.2469 28.9106 5.18565 46.4849 11.5819Z",
    fill: "#FFF4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1592 15.4062L20.2782 21.5406L25.4686 21.8852L23.1592 15.4062Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 1.11397,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3716 28.3533L20.4002 21.8691L25.5864 22.2726L22.3716 28.3533Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 1.11397,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8669 26.7271L20.0971 20.7691L23.453 24.7437L16.8669 26.7271Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 1.11397,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4499 17.7793L19.6802 23.7373L23.036 19.7627L16.4499 17.7793Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 1.11397,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3748 22.5509L22.8906 24.5223L23.2941 19.3361L29.3748 22.5509Z",
    fill: "#DC4649",
    stroke: "#DC4649",
    strokeWidth: 1.11397,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiwIcon03);
export default __webpack_public_path__ + "static/media/hiwIcon03.e18a49dcfac7ed53308664063406fb81.svg";
export { ForwardRef as ReactComponent };